/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Raffle_Pool_LabelInputs */



/**
* | output |
* | --- |
* | "Draw from" |
*
* @param {Raffle_Pool_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const raffle_pool_label = /** @type {((inputs?: Raffle_Pool_LabelInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Raffle_Pool_LabelInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tirer parmi")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sortear entre")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Sortear entre")
	if (locale === "it") return /** @type {LocalizedString} */ ("Estrai tra")
	return /** @type {LocalizedString} */ ("Draw from")
});